import { urlBaseApi } from '../consts';



export const create = (token, body) => {
  return {
    url: `${urlBaseApi}/cost-impressions/create`,
    method: 'POST',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const list = (token,page,limit) => {
  return {
    url: `${urlBaseApi}/cost-impressions/get-all?page=${page}&limit=${limit}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const one = (token, id) => {
  return {
    url: `${urlBaseApi}/cost-impressions/get/${id}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const update = (token, id, body) => {
  return {
    url: `${urlBaseApi}/cost-impressions/update/${id}`,
    method: 'PUT',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const remove = (token,id) => {
  return {
    url: `${urlBaseApi}/cost-impressions/delete/${id}`,
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const dropdown = (token) => {
  return {
    url: `${urlBaseApi}/cost-impressions/dropdown`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};